import { useMutation, useQuery } from '@tanstack/react-query';
import {
    getDbLogs,
    getDbMigrationStatus,
    getDbTableRows,
    getDbTables,
    runDbMigrationTests,
    runDbQuery,
} from './dbApi';

export const createDbHooks = () => {
    const useDbTables = () =>
        useQuery({
            queryKey: ['dbTables'],
            queryFn: getDbTables,
            staleTime: 5 * 60 * 1000,
        });

    const useDbTableRows = (options = {}) =>
        useQuery({
            queryKey: ['dbTableRows', options],
            queryFn: () => getDbTableRows(options),
            enabled: Boolean(options.table),
            keepPreviousData: true,
        });

    const useRunDbQuery = () =>
        useMutation({
            mutationFn: runDbQuery,
        });

    const useDbLogs = (options = {}) =>
        useQuery({
            queryKey: ['dbLogs', options],
            queryFn: () => getDbLogs(options),
            refetchInterval: options.refetchInterval ?? 15000,
        });

    const useDbMigrationStatus = (options = {}) =>
        useQuery({
            queryKey: ['dbMigrationStatus'],
            queryFn: getDbMigrationStatus,
            refetchInterval: options.refetchInterval ?? 30 * 1000,
        });

    const useRunDbMigrationTests = () =>
        useMutation({
            mutationFn: runDbMigrationTests,
        });

    return {
        useDbTables,
        useDbTableRows,
        useRunDbQuery,
        useDbLogs,
        useDbMigrationStatus,
        useRunDbMigrationTests,
    };
};
